import { ReactNode } from "react"

type EmployeeDashboardCardWrapperProp = {
  children: ReactNode
}
export const EmployeeDashboardCardWrapper: React.FC<
  EmployeeDashboardCardWrapperProp
> = ({ children }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 items-stretch">
      {children}
    </div>
  )
}

type EmployeeDashboardCardProp = {
  percentage: string
  badge: string | null
  title: string
  badgeColor: string | null
  badgeBgColor: string | null
  message: string
  view?: () => void
}

export const EmployeeDashboardCard: React.FC<EmployeeDashboardCardProp> = ({
  percentage,
  badgeBgColor,
  badgeColor,
  badge,
  title,
  message,
}) => {
  const isRed = badgeColor === "#E7000B"

  const arrowPath = isRed
    ? "M2.25 6 9 12.75l4.306-4.306a11.95 11.95 0 0 1 5.814 5.518l2.74 1.22m0 0-5.94 2.281m5.94-2.28-2.28-5.941"
    : "M2.25 18 9 11.25l4.306 4.306a11.95 11.95 0 0 1 5.814-5.518l2.74-1.22m0 0-5.94-2.281m5.94 2.28-2.28 5.941"

  return (
    <div className="h-full w-full border-[#E2E8F0] border rounded-lg px-3 pt-3 mt-4 flex flex-col gap-1 font-circular">
      <div className="flex items-center gap-5">
        <p className="text-padeBlack font-medium text-sm">{percentage}</p>
        {badge && badgeColor && badgeBgColor && (
          <button
            style={{ backgroundColor: badgeBgColor }}
            className="flex items-center justify-center px-1 gap-0.5 text-sm min-w-[56px] rounded-full"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke={badgeColor}
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d={arrowPath}
              />
            </svg>
            <span
              style={{ color: badgeColor }}
              className="text-[12px] font-semibold"
            >
              {badge}
            </span>
          </button>
        )}
      </div>
      <p className="text-padeBlack font-medium text-sm font-circular">
        {title}
      </p>
      <div className="text-slate-500 text-sm line-clamp-2">{message}</div>
    </div>
  )
}
